<template>
  <div class="activities">
    <mt-header title="Concurrent Activities">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="detailsContent">
      <ul>
        <li @click="$router.push('/live')" >
          <img src="http://www.cippe.com.cn/miniprogram/tq01.jpg" alt=""/>
        </li>
        <li @click="$jumpWeb('https://oil.zhenweievents.com/en/')" >
          <img src="http://www.cippe.com.cn/miniprogram/tq02.jpg" alt=""/>
        </li>
        <!-- <li @click="$router.push('/home/activities/ccpit')" >
          <img src="http://www.cippe.com.cn/miniprogram/tq03.jpg" alt=""/>
        </li>
        <li @click="$router.push('/home/activities/seminar')" >
          <img src="http://www.cippe.com.cn/miniprogram/tq04.jpg" alt=""/>
        </li> -->
        
      </ul>
    </div>
    
  </div>
</template>

<script>
import { Header } from 'mint-ui';
import "mint-ui/lib/header/style.css"
export default {
  components:{
    'mt-header':Header
  },
  data () {
    return {
      
    }
  },

}
</script>

<style scoped>
  .activities{
    /* padding:0 20px; */
    height: 100%;
    background-color: white;
  }
  .mint-header{
    /* margin-left: -20px;
    margin-right: -20px; */
    height: 40px;
    background-color: #008baf;
    position: relative;
    z-index: 10;
  }
  .detailsContent{
    position: relative;
    z-index: 10;
    background-color: white;
  }
  .activities ul{
    padding-bottom: 20px;
  }
  .activities li{
    /* padding: 10px; */
    margin-top: 20px;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, .3);
  }
</style>